/* eslint-disable no-await-in-loop */
import { sleep } from "./async";

export const jitter = ({ max, min }: { min: number; max: number }): number => {
  if (min >= max) {
    throw new Error("Min must be less than max");
  }

  return Math.floor(Math.random() * (max - min + 1) + min);
};

export interface RetryArgs<R> {
  func: (attempt: number) => Promise<R>;
  retryCount: number;
  interval: number; // in millis
}

export async function retry<R>({
  func,
  interval,
  retryCount,
}: RetryArgs<R>): Promise<R> {
  for (let i = 0; i <= retryCount; i++) {
    try {
      return await func(i + 1);
    } catch (err) {
      if (i < retryCount - 1) {
        await sleep(interval);
      } else {
        throw err;
      }
    }
  }

  throw new Error("Impossible to reach.");
}
